import Money from "theme/components/atoms/Typography/Money/Money";

export default Money;
